import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MetaDataConstant } from '@constant/meta-data.constant';
import { RouteConstant } from '@constant/route.constant';
import { environment } from '@env';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent {
  title = 'hk-b2b-igm-web';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private metaService: Meta,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      if (
        !window.location.href.includes(RouteConstant.ACCOUNT_TYPES) &&
        !window.location.href.includes(RouteConstant.CASH_SOLUTION)
      ) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 10);
      }
    });

    const lang = localStorage.getItem('locale') || 'en';
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);

    this.updateMetaTags();
    const updateMetaTags = () => this.updateMetaTags();
    this.translateService.onLangChange.subscribe(updateMetaTags);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(updateMetaTags)
  }

  updateMetaTags(): void {
    const route = this.getChild(this.activatedRoute);
    route.data.subscribe((data: any) => {
      // set browser tab title
      if (data.title) {
        this.titleService.setTitle(this.getTranslatedMetaData(data.title, 'title'));
      } else {
        this.titleService.setTitle(this.getTranslatedMetaData(MetaDataConstant.HOME.title, 'title'));
      }

      // set meta title
      if (data.metaTitle) {
        this.metaService.updateTag({ name: 'title', content: this.getTranslatedMetaData(data.metaTitle, 'metaTitle') });
        this.metaService.updateTag({ property: 'og:title', content: this.getTranslatedMetaData(data.metaTitle, 'metaTitle') });
        this.metaService.updateTag({ name: 'twitter:title', content: this.getTranslatedMetaData(data.metaTitle, 'metaTitle') });
      } else {
        this.metaService.updateTag({ name: 'title', content: this.getTranslatedMetaData(MetaDataConstant.HOME.metaTitle, 'metaTitle') });
        this.metaService.updateTag({ property: 'og:title', content: this.getTranslatedMetaData(MetaDataConstant.HOME.metaTitle, 'metaTitle') });
        this.metaService.updateTag({ name: 'twitter:title', content: this.getTranslatedMetaData(MetaDataConstant.HOME.metaTitle, 'metaTitle') });
      }
      // set meta description
      if (data.metaDescription) {
        this.metaService.updateTag({ name: 'description', content: this.getTranslatedMetaData(data.metaDescription, 'metaDescription') });
        this.metaService.updateTag({ property: 'og:description', content: this.getTranslatedMetaData(data.metaDescription, 'metaDescription') });
        this.metaService.updateTag({ name: 'twitter:description', content: this.getTranslatedMetaData(data.metaDescription, 'metaDescription') });
      } else {
        this.metaService.updateTag({ name: 'description', content: this.getTranslatedMetaData(MetaDataConstant.HOME.metaDescription, 'metaDescription') });
        this.metaService.updateTag({ property: 'og:description', content: this.getTranslatedMetaData(MetaDataConstant.HOME.metaDescription, 'metaDescription') });
        this.metaService.updateTag({ name: 'twitter:description', content: this.getTranslatedMetaData(MetaDataConstant.HOME.metaDescription, 'metaDescription') });
      }

      if (data.image) {
        this.metaService.updateTag({ property: 'og:image', content: data.image });
        this.metaService.updateTag({ property: 'og:image:width', content: '800' });
        this.metaService.updateTag({ property: 'og:image:height', content: '400' });

        this.metaService.updateTag({ name: 'twitter:image', content: data.image });
        this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
      }

      const url = window.location.href;
      this.metaService.updateTag({ property: 'og:url', content: url });
      this.metaService.updateTag({ property: 'og:type', content: 'website' });
    })
  }

  getChild(activatedRoute: ActivatedRoute): any {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  getTranslatedMetaData(translationKey: string, itemKey: 'title' | 'metaTitle' | 'description' | 'metaDescription' | 'keyword'): string {
    const translatedValue = this.translateService.instant(translationKey);
    return translatedValue;
  }
}
